export interface BatchReminderListRequest {
  returnPlansDateFrom: string
  returnPlansDateTo: string
  dunningDateFrom: string
  dunningDateTo: string
  branchCodeFrom: string
  branchCodeTo: string
  radioBranchType: string
  radioUserType: string
  userType: string
  update: string
  isSearchBooks: boolean
  isSearchAV: boolean
  isSearchMagazine: boolean
  isEnabledHoldingBooks: boolean
  bookCount: string
  isRsvCollection: boolean
  rsvCollectionCount: string
  reminderSetType: string
  mailSendType: string
  userCollectionTypeFrom: string
  userCollectionTypeTo: string
  isNotOutputUser: boolean
  isOutputTelInclude: boolean
  isNotLostCollection: boolean
  isNotLostProcedure: boolean
  isOutputDetail: boolean
  isOtherDunningDoc: boolean
  isOutputDunningUser: boolean
  isNotOutputLendStop: boolean
  isOutputSchoolAge: boolean
  isOutputOrder: boolean
  outputOrderType: string
  batchType: string
}

export function BatchReminderListRequestToJSON(
  value: BatchReminderListRequest
): any {
  return {
    return_plans_date_from: value.returnPlansDateFrom,
    return_plans_date_to: value.returnPlansDateTo,
    dunning_date_from: value.dunningDateFrom,
    dunning_date_to: value.dunningDateTo,
    branch_code_from: value.branchCodeFrom,
    branch_code_to: value.branchCodeTo,
    radio_branch_type: value.radioBranchType,
    radio_user_type: value.radioUserType,
    user_type: value.userType,
    update: value.update,
    is_search_books: value.isSearchBooks,
    is_search_av: value.isSearchAV,
    is_search_magazine: value.isSearchMagazine,
    is_enabled_holding_books: value.isEnabledHoldingBooks,
    book_count: value.bookCount,
    is_rsv_collection: value.isRsvCollection,
    rsv_collection_count: value.rsvCollectionCount,
    reminder_set_type: value.reminderSetType,
    mail_send_type: value.mailSendType,
    user_collection_type_from: value.userCollectionTypeFrom,
    user_collection_type_to: value.userCollectionTypeTo,
    is_not_output_user: value.isNotOutputUser,
    is_output_tel_include: value.isOutputTelInclude,
    is_not_lost_collection: value.isNotLostCollection,
    is_not_lost_procedure: value.isNotLostProcedure,
    is_output_detail: value.isOutputDetail,
    is_other_dunning_doc: value.isOtherDunningDoc,
    is_output_dunning_user: value.isOutputDunningUser,
    is_not_output_lend_stop: value.isNotOutputLendStop,
    is_output_school_age: value.isOutputSchoolAge,
    is_output_order: value.isOutputOrder,
    output_order_type: value.outputOrderType,
    batch_type: value.batchType
  }
}
